import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Form } from '@deere/ux.uxframe-react';
import { removeSurveyAnswer, updateSurveyAnswers } from '../../redux/action/surveyAction';
import { findAnswerIndex, updateAnswerInArray, getTranslation, getNewCheckValueAnswer, removeQuestion } from '../../utils/utils';
import {  EMPTY_BODY, SCBM_SECCIO_CODES } from '../../utils/surveyLiterals'
import store from '../../redux/store'
import "../../assets/css/Sections.css";
import {DebounceInput} from 'react-debounce-input';
import { useTranslation } from "react-i18next";
import RadioGroup from '../../components/RadioGroup';
import CheckGroup from '../../components/CheckGroup';
import TableSection from '../../components/TableSection';
import Table from '../../components/Table';


export default function CapacityConstraints({ survey }) {

    const dispatch = useDispatch()
    const [checkSection, setCheckSection] = useState("")
    const surveyResponse = useSelector(state => state.survey.surveyResponse);
    const [answers, setAnswers] = useState([])

    const { t } = useTranslation();
    const section = survey.sections.find(e => e.code === SCBM_SECCIO_CODES.CC && e.active);  
    const questions = section && section.questions ? section.questions : null

    useEffect(() => {
        setAnswers([...store.getState().survey.surveyAnswers])
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [surveyResponse])

    if (!survey)
        return EMPTY_BODY;

    const handleCheckChange = (e, idQuestion) => {

        updateCheckAnswer(e, idQuestion);
    } 

    const updateCheckAnswer = (e, questionId) => {
        let newCheckValue = getNewCheckValueAnswer(questionId, answers, e);
        if (newCheckValue === null || newCheckValue === '' || newCheckValue === ',') {//Remove Question
            removeQuestion(questionId, answers);
            dispatch(removeSurveyAnswer(questionId));
        } else {//Update Question
            updateAnswerInArray(questionId, answers, newCheckValue);
            dispatch(updateSurveyAnswers({ questionId: questionId, answer: newCheckValue }));
        }
        setAnswers([...store.getState().survey.surveyAnswers])
    }

    const updateAnswer = (e, questionId) => {
        updateAnswerInArray(questionId, answers, e.target ? e.target.value : e);
        dispatch(updateSurveyAnswers({ questionId: questionId, answer: e.target ? e.target.value : e }));
        setAnswers([...store.getState().survey.surveyAnswers])
    }

    function createRadioSection(question) {
        return (<>
                <Form.Group>
                    <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                    <div><RadioGroup key={question.id} rgIndex={''} radioLabels={question ? question.selections : []}
                        updateAnswer={updateAnswer} question={question}
                        defaultValue={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''} 
                        section={getTranslation(section, 'description')}
                        checkedProprietary={checkSection}/>
                    </div>                        
                </Form.Group>
             </>)
    } 
    
    function createCheckSection(question) {
        if (question.idQuestionDepends) {
            let qIndex = findAnswerIndex(question.idQuestionDepends, answers);
            if (qIndex >= 0 && answers[qIndex].answer === question.idSelectionDependson.toString()) {
                return(
                    <>
                        <Form.Group className="mb-4 pl-4">
                            <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                            <div><CheckGroup key={question.id} checkSelections={question ? question.selections : []}
                                handleChange={handleCheckChange} question={question}
                                currentChecked={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''} 
                                section={getTranslation(section, 'description')}
                                checkedproprietary={checkSection}/></div>
                        </Form.Group>
                    </>
                )
            }
        }else{
            return(
                <>
                    <Form.Group>
                        <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                        <div><CheckGroup key={question.id} checkSelections={question ? question.selections : []}
                            handleChange={handleCheckChange} question={question}
                            currentChecked={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''} 
                            section={getTranslation(section, 'description')}
                            checkedproprietary={checkSection}/>
                        </div>
                    </Form.Group>
                </>
            )
        }
    }
    function createTextArea(question) {
        let qDepIndex = findAnswerIndex(question.idQuestionDepends, answers);
        let questionIndex = findAnswerIndex(question.id, answers);
        if (question.idQuestionDepends && question.idQuestionDepends > 0) {
            return (qDepIndex >= 0 && answers[qDepIndex].answer >= question.idSelectionDependson) ? <Form.Group className="mb-4 pl-4">
                        <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                        <DebounceInput required={!checkSection} element="textarea" rows="2" aria-describedby="textarea-text" value={questionIndex >= 0 ? answers[questionIndex].answer : ''}
                                onChange={e => updateAnswer(e, question.id)} name={`${getTranslation(section, 'description')}-${question.id}`} className="form-control"/>
                        <div className="invalid-feedback">
                            {t('bs_required')}
                        </div>
                    </Form.Group> : null
        } else {
            return <Form.Group className="mb-4">
                        <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                        <DebounceInput required={!checkSection} element="textarea" rows="2" aria-describedby="textarea-text" value={questionIndex >= 0 ? answers[questionIndex].answer : ''}
                                onChange={e => updateAnswer(e, question.id)} name={`${getTranslation(section, 'description')}-${question.id}`} className="form-control"/>
                        <div className="invalid-feedback">
                            {t('bs_required')}
                        </div>
                    </Form.Group>
        }
    }

    return (<>
        <Card>
            <Card.Body id={section ? section.description : ''}>
                <Card.Title className='pb-3 font-weight-bold'>
                    {getTranslation(section,'description')}                    
                </Card.Title>                                 
                <>
                    {
                        <>
                            {
                              questions && questions.sort((a,b) => (a.showOrder > b.showOrder)? 1 : -1).map((q,index) =>
                                    <Form.Row className="d-block mb-4" key={index}>
                                        {q.type === 'RADIO' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createRadioSection(q) : <></>}
                                        {q.type === 'OPEN' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createTextArea(q) : <></>}
                                        {q.type === 'CHECK' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createCheckSection(q) : <></>}
                                        {q.type === 'TABLE_SECT' ? <TableSection question={q} updateAnswer={updateAnswer} answers={answers} section={getTranslation(section, 'description')} checkedProprietary={checkSection} questions={questions}/> : <></>}
                                    </Form.Row>
                                )
                            }
                        </>
                    }
                </>
                <Table section={section} questions={questions} updateAnswer={updateAnswer} answers={answers} checkedProprietary={checkSection} isTotal={true}/>
                
            </Card.Body>
        </Card>
    </>)
}